import axios from 'axios';

// Create a custom axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token in requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for better error handling
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Axios error:', error);
    
    // If the error is a network error, provide a more user-friendly message
    if (error.message === 'Network Error') {
      console.log('Network error detected. Checking API availability...');
      
      // Try to ping the API to see if it's available
      axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/health`, { timeout: 5000 })
        .then(() => {
          console.log('API is available, but the request failed for another reason');
        })
        .catch((pingError) => {
          console.error('API ping failed:', pingError);
        });
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance; 